class ReportTableYearController {
	private reportYears: any;
	private businessCaseId: string;

	constructor (private reportYearService: any) {}

	$onChanges (changesObj) {
		if (changesObj.businessCaseId && changesObj.businessCaseId.currentValue) {
			this.loadReportYears(changesObj.businessCaseId.currentValue);
		}
	}
	
	private loadReportYears (businessCaseId: string) {
		this.reportYearService.getReportYearsByBusinessCaseId(businessCaseId).then((reportYears) => {
			this.reportYears = reportYears;
		});
	}

	public removeReportYear (reportYear: any) {
		this.reportYearService.removeReportYear(reportYear.id).then(() => this.loadReportYears(this.businessCaseId));
	}

	public editReportYears () {
		this.reportYearService.openEditDetailModal(this.businessCaseId).finally(() => this.loadReportYears(this.businessCaseId));
	}
}

ReportTableYearController.$inject = ['reportYearService'];

export default ReportTableYearController;


// WEBPACK FOOTER //
// ./src/app/components/report/ReportTableYearController.ts